module.exports = __webpack_public_path__ + "img/level-curved-sec.c6e6a94f.svg";